// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer__wrapper[data-v-ace38950]{background-color:#0a0b0d;position:relative}.footer__wrapper .footer__container[data-v-ace38950]{max-width:1440px;padding:96px 64px}@media (max-width:1439px){.footer__wrapper .footer__container[data-v-ace38950]{padding:72px 64px}}@media (max-width:767px){.footer__wrapper .footer__container[data-v-ace38950]{padding:32px 16px 64px}}", ""]);
// Exports
module.exports = exports;
